module.exports = __webpack_public_path__ + "static/media/ios-print.4a677416.svg";